// extracted by css-extract-rspack-plugin
export default {"SavedViewsList":"Sidebar-module__SavedViewsList__cntqKGl","SidebarContainer":"Sidebar-module__SidebarContainer__Yina5NZ","sidebarFooter":"Sidebar-module__sidebarFooter__tLJLaCM"};